<template>
  <div class="horizontal-detail" :class="!valid && 'invalid'">
    <div class="detail-title" v-if="empty" />
    <span class="detail-title" v-html="`${label} :`" v-else />
  </div>
</template>
<script>
export default {
  name: 'HorizontalDetailTitle',
  props: {
    label: {
      type: String,
      default: '',
    },
    valid: {
      type: Boolean,
      default: true,
    },
    empty: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style lang="scss" scoped></style>
